module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "من-المعتقد-إلى-المعرفة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من المُعتَقدِ إلى المَعرفةِ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حانَ الوقتُ لنحطِّمَ بعضَ أصنامِ الفشلِ، حانَ الوقتُ لنستكشفَ أحلامَنا، حانَ الوقتُ لهدمِ بعضِ المعتقداتِ، فالتّغلّبُ على الأوهامِ الّتي تغزو عقلَنا هيَ أوّلُ وأهمُّ الخُطواتِ في طريقِ بحثنا عن النّجاحِ. حينَما حطّمَ \"إبراهيمُ\" (عليه السّلام) أصنامَ قومهِ؛ لم يكُن هدفهُ إلّا أن يهدمَ مُعتَقداً ويبنيَ معرفةً، نحنُ كذلكَ نعتقدُ بأنّنا سنفشلُ في تحقيقِ أهدافِنا من دونِ أن نخوضَ تحدياتِنا، فسجنُ المعتقداتِ لا يزالُ يحبسُ أفكارنا وطموحتِنا خلفَ قضبانِ الوهم، ويُغلقُ نوافذَه عن شمسِ المعرفةِ والعلمِ. لِننقلْ تجربةَ أحلامِنا من المعتَقدِ إلى المعرفةِ، أو من الخيالِ إلى الواقعِ. لِنخض التّجربةَ، لنكتشِف أسبابَ إخفاقِنا، لنتفادَ أخطاءَ تجاربِنا الأُولى خلالَ تجاربنا التّالية، ولنستكشفِ الطّاقةَ الإعجازيّةَ الكامنةَ في داخلِنا. التفكيرُ في الأوهامِ والفشلِ دونَ خوضِ التّجربةِ سيصنعُ من أحلامِنا مجرّدَ أطيافٍ، ولكنَّ خوضَ التّجربةِ سيُنيرُ بصائرَنا بنقاطِ ضعفِنا، وهو ما سيساعدُنا على تفاديها في المحاولاتِ التّاليةِ. الاعتقادُ بالفشلِ دونَ السّعي للبحثِ عن المعرفةِ هوَ سرابٌ مؤقتٌ وخادعٌ لكلِّ مَن يسعى للوصولِ إلى واحةِ أحلامهِ، وللتّحقُّقِ من الأمرِ لابدَّ من السّعي للاقترابِ من ذلكَ السّراب. كثيرٌ من الأحلامِ الّتي اعتقدَ الآخرونَ بأنَّ مجرّدَ التّفكيرِ فيها يُعتبرُ ضربٌ من الجنونِ، كالوصولِ إلى الفضاءِ مثلاً أو الطّيران، ولكنَّ من سعوا لمحو صورةِ الفرضياتِ والاعتقاداتِ والانتقالِ الى عالمِ المعرفة، هم من نقلُوا تلكَ الأحلامَ إلى أرضِ الواقعِ. سعيُنا الحثيثُ لصناعةِ اعتقاداتٍ حولَ عدمِ قدرتِنا على تحقيقِ أحلامِنا سينتهي بنا إلى سجنٍ مظلمٍ من المعتقداتِ، وسيُعمي أبصارَنا عن رؤيةِ نورِ المعرفةِ، لنحطِّمْ قيودَ جهلِ معتقداتِنا، ولنبحِرْ في بحرِ المعرفةِ، حينَها سنُدركُ أنَّ المعتقداتِ ما هيَ إلّا جزيرةٌ علقَ بها قاربُ معرفتِنا، لننقلْ إلى عالمِ المعرفةِ، عالمنا الحقيقيّ ولندعِ الأوهامَ للآخرين.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "padding-top": "30px"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تستطيع..")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4788824c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch010.vue
// module id = 87
// module chunks = 0